export default "__VITE_ASSET__BdoEnGmA__ 430w";